import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    header: {
        background: '#E8E8E8',
        display: 'flex',
        alignItems: 'center',
        height: '49px',
        padding: '0px 0px 0 15px',
        "& h1": {
            padding: '0px 15px',
            fontSize: '22px',
            fontWeight: 600,
            lineHeight: '28.8px',
            color: '#2D4D95',
        }
    },
    statusBoxes: {
        position: 'relative',
        alignItems: 'inherit',
        width: '100%',
        borderRadius: '18px',
        padding: '6px 0px 0px 8px',
        margin: 'auto',
        display: 'flex',
        minHeight: '160px',
        justifyContent: 'center',
        width: '100%',
        alignItems: 'center',
        "& img": {
            padding: '0px 8px 0px 0px',
            marginLeft: 'auto',
            maxWidth: '53px',
        },
        "& h3": {
            color: 'white',
            fontSize: '25px',
            margin: '5px 0',
            display: 'flex',
            fontWeight: 500,
            alignItems: 'center',
        },
        "& h1": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '36px',
            lineHeight: '43px',
            display: 'flex',
            alignItems: 'center',
            color: '#FFFFFF',
            margin: '0 9px',
            justifyContent: 'right',
        }
    },
    gridHeader: {
        padding: '6px 15px',
        display: 'flex',
        flexFlow: 'wrap',
          alignItems: 'center',
        justifyContent: 'right',
      },
      gridActions: {
        textAlign: 'right',
        display: 'flex',
        alignItems: 'center',
        "& Button": {
            color: 'white',
            marginRight: '7px',
            textTransform: 'capitalize',
            background: '#454545 !important',
            padding: '7px 18px',
            margin: '5px',
            "& hover": {
                background: '#454545',
            }
        }
      },
      
      changeBtn: {
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '6px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },

    statusBoxContainer: {
        display: 'flex',
        marginBottom: '10px',
        width: '100%',
        flexFlow: 'wrap',

        "& .Total": {
            background: '#7f84b63d',
            border: '1px solid #9497b6',
            "& span": {
                fontSize: '35px',
                color:'#474a69',
            },
            "& h3": {
                color:'#474a69',
            }
        },
        "& .Total:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #7f84b6 0%, #474a69 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            color: 'white',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },
        "& .Mui-checked + span > .Total": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #7f84b6 0%, #474a69 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
              "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },
        "& .Mui-checked + span > .Total::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Mui-checked + span > .Total>span": {
            fontSize: '35px',
            color:'white',
        },
        "& .Mui-checked + span > .Total>h3": {
            color:'white',
        },
       
        "& .Pending": {
            background: 'linear-gradient(0deg, rgba(240, 199, 255, 0.3), rgba(240, 199, 255, 0.3))',
            border: '1px solid #53bbff',
            "& span": {
                fontSize: '35px',
                color:'#1a8cd6',
            },
            "& h3": {
                color:'#1a8cd6',
            }
        },
        "& .Mui-checked + span > .Pending": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #77C5F8 0%, #00375B 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },
        "& .Mui-checked + span > .Pending::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Pending:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #77C5F8 0%, #00375B 100%)',
            backgroundRepeat: 'no-repeat',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },

        "& .Delivered": {
            background: '#a5ffd3',
            border: '1px solid #53E69D',
            "& span": {
                fontSize: '35px',
                color:'#27be73',
            },
            "& h3": {
                color:'#27be73',
            }
        },
        "& .Mui-checked + span > .Delivered": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #53E69D 0%, #3ab377 100%);',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },
        "& .Mui-checked + span > .Delivered::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Delivered:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #53E69D 0%, #3ab377 100%);',
            backgroundRepeat: 'no-repeat',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },
    

        
        "& .Enrolled": {
            background: '#ffdfb1',
            border: '1px solid #f0bd73',
            "& span": {
                fontSize: '35px',
                color:'#a97c3b',
            },
            "& h3": {
                color:'#a97c3b',
            }
        },
        "& .Mui-checked + span > .Enrolled": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #D6B482 0%, #6F4200 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },
        "& .Mui-checked + span > .Enrolled::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Enrolled:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #D6B482 0%, #6F4200 100%);',
            backgroundRepeat: 'no-repeat',
            "& span": {
                fontSize: '35px',
                color:'white',
            },
            "& h3": {
                color:'white',
            }
        },

        "& .Rejected": {
            background: '#ff300f',
            border: '1px solid #514343',
            "& span": {
                fontSize: '35px',
                color: '#ffffff',
            },
            "& h3": {
                color: '#ffffff',
            }
        },
        "& .Mui-checked + span > .Rejected": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #ff0000  0%, #340000  100%);',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            "& span": {
                fontSize: '35px',
                color: 'white',
            },
            "& h3": {
                color: 'white',
            }
        },
        "& .Mui-checked + span > .Rejected::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .Rejected:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #ff0000  0%, #340000  100%);',
            backgroundRepeat: 'no-repeat',
            "& span": {
                fontSize: '35px',
                color: 'white',
            },
            "& h3": {
                color: 'white',
            }
        },
    
        "& .MuiCheckbox-colorPrimary": {
            position: 'absolute',
        }
    },
    checkBoxFormLabel: {
        margin: '0px 2px 5px 2px',
        width: window.isMobileView ? '48%': '18%',
    },
    checkBoxBtn: {
        marginLeft: "0px",
        paddingRight: "5px",
        "& + .MuiFormControlLabel-label": {
            color: "#52575C",
            fontSize: "14px",
            width: '100%',
        },
        "& .MuiSvgIcon-root": {
            opacity: 0,
            display: 'none',
        }
    },
    statusBoxContent: {
        flex: 1,
        minWidth: 0,
     
        "& h2": {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '36px',
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            color: 'white',
            justifyContent: 'right',
            marginRight: '9px',
        },
        "& h5": {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            color: '#10B921',
        },
      
    },
    distributedDevicesCount: {
        position: 'absolute',
        right: '10px',
        bottom: '8px',
        fontSize: '13px',
        fontWeight: 400,
        color: 'white',
        textAlign: 'right',
        '& strong': {
            fontSize: '18px',
            fontWeight: 700,
        },
    },
    heading: {
        fontWeight: 700,
        fontSize: '20px',
        margin: '0px',
        color: '#3C4549',
    },
    container: {
        padding: '6px 15px',
    },


    legend:{
        display: 'flex',
        //alignItems: 'center',
        gap:'8px'
      },
      colorIndicator: {
        width: '1rem',
        height: '1rem',
        
      },
    
}));
